import React from "react";
import { Flex, Text } from "rebass";
import { MdChevronLeft } from "react-icons/md";

interface IProps {
  name: string;
}

export const ParentItem: React.FC<IProps> = ({ name }) => (
  <Flex
    alignItems="center"
    p="11px"
    pr="20px"
  >
    <Flex width="64px" justifyContent="center" color="wild-blue">
      <MdChevronLeft display="block" size={26} />
    </Flex>

    <Text
      fontSize="16px"
      fontWeight="normal"
      lineHeight={1.19}
      color="zodiac"
      css="text-overflow: ellipsis; white-space: nowrap;"
    >
      <span>Back to</span>

      &nbsp;

      <b>{name}</b>
    </Text>
  </Flex>
);
